import { PageLink } from "../../../../../../_metronic/layout/core"
import { DEFAULT_ROLES } from "../../../../../common/core/_consts"
import { REQUISITE_VIEW_ROLES } from "./access"

export const REQUISITES_BREADCRUMBS: Array<PageLink> = [
{
    title: 'Доступные для резервирования',
    path: '/settings/requisite/list-enabled',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Недоступные для резервирования',
    path: '/settings/requisite/list-disabled',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Фаст трек',
    path: '/settings/requisite/list-fasttrack',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Типы реквизитов',
    path: '/settings/requisite/types',
    isSeparator: false,
    isActive: false,
    roles: DEFAULT_ROLES,
  },
]